const paths = {
  home: "/",
  about: "/about",
  portfolio: "/portfolio",
  contact: "/contact",
  media: "/media",
  ourart: "/ourart",
  homeMy: "/my",
  artist: "/artist",
  pricing: "/pricing",
  membership: "/membership",
  shipping: "/shipping",
  products: "/products",
  projects1: "/projects-1",
  projects2: "/projects-2",
  projects3: "/projects-3",
  projects4: "/projects-4",
  project: "/projects/:keyword",
};
export default paths;
